import React from "react";
import API from "../base/API";
import { translate } from "../base/Translation";
import { logOut } from "../auth/Auth";
import Storage from "../base/Storage";

export default class UserAgreementPromnt extends React.Component {

    constructor(props) {
        super(props);

        this.api = new API({
            save_agreements: "/user/agreement/save"
        });
    }

    next() {
        let canNext = false;

        let documents = [];

        for (let index in this.refs) {
            let item = this.refs[index];
            let documentId = index.split("_")[1];

            canNext = item.checked;

            if (!canNext) {
                break;
            }

            documents.push(documentId);
        }

        if (!canNext) {
            alert(translate("Musíte súhlasiť so všetkými dokumentami"));
            return;
        }

        this.api.request({
            route: "save_agreements",
            data: { documents },
            success: (response) => {
                Storage.set("skip_docs", "yes");
                window.location.reload();
            }
        });
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-4 col-md-offset-4">
                        <div className="login-panel panel panel-default">
                            <div className="panel-heading" style={{ position: "relative" }}>
                                <h2 style={{ marginTop: 0, marginBottom: 0, textAlign: "center" }}>
                                    trend&nbsp;
                                        <small style={{ fontSize: "12px" }}>by TOPTEST s.r.o.</small>
                                </h2>
                                <button className="btn btn-xs" style={{ position: "absolute", right: "5px", top: "0px" }} onClick={logOut} title={translate("Odhlásenie")}>
                                    <span className="fa fa-times" />
                                </button>
                            </div>
                            <div className="panel-body">
                                <p>
                                    {translate("Pred pokračovaním musíte súhlasiť s nasledujúcimi dokumentami:")}
                                </p>
                                <ul className="list-group list-group-flush">
                                    {this.props.documents.map((item, index) => {
                                        return (
                                            <label key={index} className="list-group-item">
                                                <input type="checkbox" defaultChecked={false} ref={"agreement_" + item.id} />&nbsp;&nbsp;
                                                <a href={item.url} target="_blank">{translate(item.name)}</a>
                                            </label>
                                        )
                                    })}
                                </ul>
                                <button className="btn btn-primary" onClick={this.next.bind(this)}>
                                    {translate("Pokračovať")} <span className="fa fa-arrow-right" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/user/UserAgreementPromt.jsx